import type { FaireProductEntity } from "../../entity_types/product";

export const p_22wnwm2hej: FaireProductEntity = {
  token: "p_22wnwm2hej",
  type: "product",
  name: "Ojai Pixie Tangerine Fruit Candle",
  brandToken: "b_jjjtg8q5tq",
  brandName: "Pixie Candle Studio",
  imageUrl:
    "https://cdn.faire.com/fastly/3a2bb7c1ad14aea173067e754362ceb54ba30ee84a7df069ddd1aac606b8fa2b.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/1a3caa59716bbf505a708b6c82596eb999e6d15eb61bceb31f585137f7f902d1.jpeg",
    "https://cdn.faire.com/fastly/f33f01d5c398bd4413714768b6da89c8e648a3fbc4bdc4bde85c5194833e9460.jpeg",
    "https://cdn.faire.com/fastly/7990fe5dace62bf0fa5759827997a19c7163db1b7ea4b7f5731a111f41fd4f52.jpeg",
    "https://cdn.faire.com/fastly/4f592dc210913ccbc488a6b04d18f7dbfee2008b682a525f8302eef166a33e4c.jpeg",
    "https://cdn.faire.com/fastly/3109c88e706ef97288a620410a54e336ebb35f48201136e91149c007e0341bc1.jpeg",
  ],
  priceDollars: 7,
  description:
    "Our best seller, the Ojai Pixie Tangerine Candle, fills your space with the vibrant scent of orange blossoms. Perfectly crafted for a refreshing ambiance, this candle brings a touch of citrus delight to any room. Experience the invigorating fragrance that makes it a favorite among our customers. Light up and enjoy the essence of blooming tangerine groves.\n\nPlease note: These are not individually packaged. They look beautiful in a bowl together!\n\nPixie Promise: No Phthalates, No Known Carcinogens, No DNA Mutagens, No Reproductive Toxins, No Organ Toxins\n\n• 5 oz\n• Non-toxic soy wax\n• Please encourage your customers to use a tray or plate under the tangerine.\n• Made to order\n\nNote to event planners: We now offer blank tags so you can write guest names on the tags. Please send us a message if you would like this type of tag.",
  tags: [],
  msrpDollars: 13,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:47:58.241Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
